import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { AllowedPlatformsType } from '../../tournament/models/tournaments.interface';
import { endpoints } from '../../utils/endpoints';
import {
    AddGameAccountRequest,
    ChangePlayerProfileRequest,
} from '../models/api/requests/profileGeneral.request';
import {
    AddGameAccountResponse,
    ChangePlayerProfileResponse,
    ProfileStatistics, ReferralsResponse,
} from '../models/api/responses/profileGeneral.response';
import {
    BaseProfileInfo,
    Player,
    Profile,
} from '../models/currentPlayer.interface';

@Injectable(
    {
        providedIn: 'root',
    }
)
export class ProfileGeneralService {
    private http = inject(HttpClient);


    getCurrentPlayerData(): Observable<Profile> {
        return this.http
            .get<Profile>(endpoints.userProfile.children.currentUser)
            .pipe(shareReplay());
    }

    getPlayerData(profileId: string) {
        return this.http
            .get<Player>(
                endpoints.userProfile.children.getUserProfileById(profileId)
            )
            .pipe(shareReplay());
    }
    getPlayerRefData(influencerProfileId: string) {
        return this.http.get<ReferralsResponse[]>(
            endpoints.userProfile.children.getRefCodeData(influencerProfileId),
        )
        .pipe(shareReplay());
    }

    getBaseInfo(userId: string) {
        return this.http
            .get<BaseProfileInfo>(
                endpoints.userProfile.children.getBaseInfoByUserId(userId)
            )
            .pipe(shareReplay());
    }

    changePlayerProfileData(
        data: ChangePlayerProfileRequest
    ): Observable<ChangePlayerProfileResponse> {
        return this.http
            .put<ChangePlayerProfileResponse>(
                endpoints.userProfile.endpoint,
                data
            )
            .pipe(shareReplay());
    }

    addGameAccount(
        account: AddGameAccountRequest
    ): Observable<AddGameAccountResponse> {
        return this.http
            .post<AddGameAccountResponse>(
                endpoints.playerAccounts.children.getConnectPlayerAccountUrl(
                    account.playerProfileId
                ),
                account
            )
            .pipe(shareReplay());
    }

    deleteGameAccount(accountId: string): Observable<any> {
        return this.http.delete<any>(
            endpoints.playerAccounts.children.deletePlayerAccountById(accountId)
        );
    }

    fetchProfileStatistics(
        playerId: string,
        gameId?: string,
        platform?: AllowedPlatformsType
    ) {
        let params = new HttpParams();

        if (gameId && platform) {
            params = params.append('gameId', gameId);
            params = params.append('platform', platform);
        }

        return this.http
            .get<ProfileStatistics>(
                endpoints.userProfile.children.getPlayersStatistics(playerId),
                {
                    params,
                }
            )
            .pipe(shareReplay());
    }
    fetchPlayerSubscriptions(query: any, id: string): Observable<any> {
        return this.http.get<any>(
            endpoints.billing.children.fetchSubscriptions(query, id)
        )
    }
    upgradeSubscription(body:any): Observable<any> {
        return this.http.post<any>(
            endpoints.billing.children.upgradeSubscription(body.profileId), {
                ...body
            }
        );
    }
}
